module.exports = __webpack_public_path__ + "static/media/11-11.8b323218.mp3";